export const PATIENT_LIST = '/u/customers';
export const PATIENT_CREATE = '/u/customers/create';
export const PATIENT_DETAIL = '/u/customers/:id([a-z0-9-]{36})';
export const PATIENT_DETAIL_RAW = '/u/customers/:id';
export const PATIENT_EDIT = '/u/customers/:id/edit';
export const PATIENT_DELETE = '/u/customers/:id/delete';
export const PATIENT_RECOVER_PASSWORD = '/u/customers/:id/recover-password';

export const TEST_REQUEST = '/u/team/test-request';
export const TEST_RESULT = '/u/customers/:patientId/test/:testId';
export const EVENT_CREATE = '/u/team/events/create';
export const EVENT_EDIT = '/u/team/events/:id(\\d+)';
export const EVENT_EDIT_RAW = '/u/team/events/:id';

export const COMPANY_EDIT = '/u/company/edit';
export const COMPANY_DETAIL = '/u/company';
export const COMPANY_UPDATE_PAYMENT_METHOD = '/u/company/subscription-plan/update-payment-method';
export const COMPANY_METRICS = '/u/company/metrics';
export const INACTIVE_COMPANY = '/u/company/inactive-company';
export const SUBSCRIPTION_PLAN_PAYMENT = '/u/company/subscription-plan/payment';

export const DOCTOR_LIST = '/u/company/team';
export const DOCTOR_CREATE = '/u/company/team/create';
export const DOCTOR_EDIT = '/u/company/team/:id([a-z0-9-]{36})';
export const DOCTOR_EDIT_RAW = '/u/company/team/:id';
export const DOCTOR_DELETE = '/u/company/team/:id/delete';
export const DOCTOR_DELETE_RAW = '/u/company/team/:id/delete';
export const DOCTOR_RECOVER_PASSWORD = '/u/team/:id/recover-password';
export const DOCTOR_RECOVER_PASSWORD_RAW = '/u/team/:id/recover-password'

export const SELF_PERFORMED_TEST_ALERT_LIST = '/u/team/self-performed-test-alerts';



export default {
  INACTIVE_COMPANY,
  SUBSCRIPTION_PLAN_PAYMENT,
  TEST_REQUEST,
  SELF_PERFORMED_TEST_ALERT_LIST,
  PATIENT_LIST,
  PATIENT_CREATE,
  PATIENT_DETAIL,
  PATIENT_EDIT,
  PATIENT_DELETE,
  PATIENT_RECOVER_PASSWORD,
  TEST_RESULT,
  EVENT_CREATE,
  EVENT_EDIT,
  COMPANY_DETAIL,
  COMPANY_METRICS,
  COMPANY_UPDATE_PAYMENT_METHOD,
  DOCTOR_LIST,
  DOCTOR_CREATE,
  DOCTOR_EDIT,
  DOCTOR_DELETE,
  DOCTOR_RECOVER_PASSWORD,
  COMPANY_EDIT
};
